var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('u-items-summary',{attrs:{"tag":_vm.tag,"limit":1,"field":_vm.fieldFunc,"items":_vm.items,"title":_vm.$t('_.object_items', { object: _vm.$t('_.order') })}})}
var staticRenderFns = []

export { render, staticRenderFns }